import HttpUtil from "ips/ac/util/HttpUtil";
import Util from "ips/ac/util/Util";
import { FormDto } from "ips/ac/model/api/WinDoFlow.api.types";

/**
 * @namespace ips.ac
 */
export default class FormService {
  public static async getForm(formGuid: string) {
    return await HttpUtil.get(FormService.getUrl(formGuid));
  }

  public static async putForm(form: FormDto) {
    // todo remove unnecessary fields
    return await HttpUtil.put(FormService.getUrl(form.guid), form);
  }

  private static getUrl(path: string): string {
    return Util.getIpsConfig().getProperty("/RestApi") + "/form/" + path;
  }
}
